import isEmpty from './isEmpty'
import getAdjReason from './getAdjReason'
//---------------------------------
// simple name -> label lookup map
//---------------------------------
const adjNameMap = {
  ca: 'CA',
  cr: 'CR',
  damage_mod_melee: 'Damage Mod (Melee)',
  damage_mod_ranged: 'Damage Mod (Ranged)',
}
//---------------------
// map adj name helper
//---------------------
function mapAdjName(name) {
  if (isEmpty(name)) return ''
  return adjNameMap[name] || name
}
//--------------------------
// build adj reasons string
//--------------------------
export default function buildAdjReasonsString(adjs) {
  console.log('--------------------------')
  console.log('IN buildAdjReasonsString')
  console.log('ADJS PASSED IN = ', window.$deepCopy(adjs))

  if (isEmpty(adjs)) {
    return ''
  }
  let reason_string = ''
  // track unique adjustments so we don't render duplicates
  const seen = new Set()
  //-----------
  // loop adjs
  //-----------
  adjs.forEach((a) => {
    console.log('PROCESSING ADJ reason = ', a.adj_reason, ' / value = ', a.adj_value)
    // build a simple uniqueness key from core fields
    const key = `${a.name || ''}|${a.adj_reason || ''}|${a.adj_value ?? ''}`
    if (seen.has(key)) {
      return
    }
    seen.add(key)
    //------------------------
    // build this adj reasons
    //------------------------
    if (!isEmpty(a.adj_reason)) {
      const namePart = !isEmpty(a.name) ? mapAdjName(a.name) + ' - ' : ''
      let reason = getAdjReason(namePart + a.adj_reason, a.adj_value)
      // first adj pass
      if (isEmpty(reason_string)) {
        reason_string = reason
      } else {
        // subsequent adj passes
        reason_string += '. ' + reason
      }
    }
  })
  return reason_string
}
